export default "__VITE_ASSET__DfgVDQnK__"